<template>
  <div class="map_container">
    <svg class="base_map_embed" ref="svgMap" width="100%" :height="height">
      <g ref="world_countries"></g>
      <g ref="world_lines"></g>
    </svg>
  </div>
</template>

<style>

  path.provider-path {
    stroke: var(--app-color-dark);
    fill: transparent;
    stroke-width: 0.5;
  }

  path.pandora-link {
    stroke-dasharray: 100%;
    fill: #ebe7e780;
    stroke: #fff;
  }

  path.provider-path.active {    
    fill: var(--app-color-red) !important;
  }

  svg.base_map_embed {
    opacity: 1;
    transition: opacity 1.5s ease-in-out;
  }

</style>

<script>
  import * as d3 from 'd3'
  import { geoMercator } from 'd3-geo'

  export default {
    name: 'ProviderMapHeaderEmbed',
    props: {
      scaleTo: Number,
      centerTo: Array,
      activeCountry: String,
      countries: Array
    },
    mounted() {
      this.renderMap()
    },
    data() {
      return {
        openMenu: false,
        width: 720,
        height: 750,
        center: [],
        scale: 100,
        distance: 0,
        bounds: [],
        center_device: [],
        zoomed: false
      }
    },
    watch: {
      countries() {
        this.renderMap()
      }
    },
    computed: {
			world_json() {
				return require("../data/worldmap.json")
			},
      projection () {
        return geoMercator()
          .translate([this.width/2, this.height/2])
          .scale(this.scale)
      },
			path () {
        return d3.geoPath().projection(this.projection)
      },
    },
    methods: {
      scrollTrigger() {
      },
      zoomTo(center, scale) {
        let base = d3.select(this.$refs['world_countries'])
        // let center, scale

        const r = d3.interpolate(this.center, center)
        const s = d3.interpolate(this.scale, scale)

        base.selectAll('path.country-path')
          .transition()
          .duration(750)
          .attrTween('d', (d) => {
            return (t) => {
              this.projection
                .scale(s(Math.pow(t,2)))                    
                .center(r(Math.pow(t,0.33)))
                .translate(this.center_device)                    
                
                this.path.projection(this.projection)

              return this.path(d)
            }
          })
					.on('start', () => {
            this.zoomed = !this.zoomed
          })
					.on('end', () => {
            this.scale = scale
            this.center = center
            this.zoomed = !this.zoomed
              
          })
      },
      renderMap() {

        let base = d3.select(this.$refs['world_countries'])

				this.bounds = d3.geoBounds(this.world_json)

        this.height = window.innerHeight *.85

        this.width = document.querySelector(".map_container").offsetWidth

				this.distance = d3.geoDistance(this.bounds[0], this.bounds[1])

				this.bounds = d3.geoBounds(this.world_json)

				this.center = this.centerTo

				this.center_device = [this.width/1.9, this.height/1.5]

				this.projection
					.translate(this.center_device)
					.center(this.center)
					.scale(this.scale)

				base.selectAll('path.provider-path').remove()

				base.selectAll('path')
					.data(this.world_json.features)
					.enter()
					.append('path')
					.attr('d', this.path)
					.attr('id', d => {
						return `${d.properties.iso_a3}`
					})
					.attr('class', d => {
            if(this.countries.indexOf(d.properties.iso_a3) > -1) {
              return `active provider-path path-${d.properties.iso_a3}`
            }
            return `provider-path path-${d.properties.iso_a3}`
					})

      }
    }
  }
</script>